import map from 'lodash/map'
import { useRouter } from 'next/router'
import React, { FC, useContext } from 'react'
import styled from 'styled-components'

import { Loading } from '@Components/Modal/Loading'
import useShippingLabels from '@Components/Shipping/useShippingLabels'
import { svgURL } from '@Globals/Cloudinary'
import { MetadataContext } from '@Globals/Metadata'
import { formatMoney } from '@Globals/Money'
import { useTranslation } from '@Globals/Translations'
import { UserContext } from '@Globals/User'

import {
  ShippingDeliveryTime,
  ShippingDescription,
  ShippingInfo,
  ShippingLogo,
  ShippingLogoWrapper,
  ShippingOption,
  ShippingOptions,
  ShippingThreshold,
  ShippingThresholdPrice,
  ShippingWrapper,
} from './styled'

export const StyledSubtitle = styled.div(({ theme }) => ({
  color: theme.colors.grey,
  lineHeight: '1.4',
}))

export interface ShippingPricingProps {
  showFreeShippingDescription: boolean
}

export const ShippingPricing: FC<ShippingPricingProps> = ({ showFreeShippingDescription }) => {
  const { store } = useContext(MetadataContext)
  const { userData } = useContext(UserContext)
  const { data: shippingOptions, error, isValidating } = useShippingLabels()
  const isLoading = (!store || !userData || isValidating) && !error
  const { tDanger } = useTranslation()
  const { locale = '' } = useRouter()

  const freeShippingThreshold = store?.config?.freeShippingThreshold || false

  if (isLoading) { return <ShippingWrapper><Loading /></ShippingWrapper> }

  return (
    <ShippingWrapper>

      {freeShippingThreshold && showFreeShippingDescription && (
        <ShippingDescription
          {...tDanger(
            'header:DELIVERY_INFO_INTRO_TEXT_WITH_THRESHOLD',
            { arg1: formatMoney(store?.id, locale, freeShippingThreshold) },
          )}
        />
      )}

      {freeShippingThreshold && (
        <ShippingThreshold
          {...tDanger(
            'shipping:ORDERS_OVER_X_THRESHOLD',
            { arg1: formatMoney(store?.id, locale, freeShippingThreshold) },
          )}
        />
      )}

      <ShippingOptions>
        {map(
          shippingOptions,
          (option => (
            <ShippingOption>
              <ShippingLogoWrapper>
                <ShippingLogo
                  alt="es"
                  loading="lazy"
                  src={svgURL(`frontend/shipping-logos/${option.companyId}.svg`)}
                />
              </ShippingLogoWrapper>

              <ShippingInfo>
                {option.type}

                <ShippingDeliveryTime>
                  {option.deliveryTime}
                </ShippingDeliveryTime>
              </ShippingInfo>

              <ShippingInfo>
                {option.price}
              </ShippingInfo>

              <ShippingThresholdPrice>
                {option.thresholdPriceIsFree
                  ? <strong>Free</strong>
                  : option.thresholdPrice}
              </ShippingThresholdPrice>

            </ShippingOption>
          )),
        )}

      </ShippingOptions>

    </ShippingWrapper>
  )
}
